export default __webpack_public_path__ + "static/17-47650ce6fafafcc83e5cd1a0cf5943f2.png";